import React from 'react'
import Fragment from '../common/fragment'

function FragmentDV(props) {
  return (
    <Fragment pos="vvvv" {...props}>
      <p>
  Petardos y trompetas
  Vendedores y carros
        <br />
  Voces interiores y gritos
        <br />
  Risas y también la angustia
        <br />
  Una ciudad, las ruinas y sus sombras
        <br />
  Seres y lenguajes
        <br />
  Calles y diagramas
        <br />
  Vidas
        <br />
  Dioses y hechizos
        <br />
  Oscuridad repentina y claridad
        <br />
  Petróleo hule miel
        <br />
  Trenes y palomas
        <br />
  A veces, la gloria
        <br />
  Plazas de piedra
        <br />
  El aire de las azoteas
        <br />
  El humo y el viento
        <br />
  Abejas
        <br />
  Abejas
        <br />
  Salamanca Salamanca Salamanca Salamanca
        <br />
  Niños corriendo bajo la sombra de los árboles
        <br />
  Luz del mediodía
        <br />
  Puestos de helados
        <br />
  Bardas frutos hierba
        <br />
  Diagramas episcopales y documentos secretos
        <br />
  Charcos y esas nubes, estas nubes
        <br />
  Otros charcos
        <br />
  Caminos de tierra
        <br />
  Dólmenes Máscaras Chimeneas
        <br />
  Muñecos de cera
        <br />
  Abejas de cristal
        <br />
  Vientos de plástico
        <br />
  Valles y ovejas
        <br />
  Balidos
        <br />
  Dios
        <br />
  Zumbido de abejas
        <br />
  Troya Troya Troya
        <br />
  Tan triste tu derrota
        <br />
  Hermoso Caballo de madera
        <br />
  Tan bello regalo y su vientre de muerte
        <br />
  Agonías de Cristos ocultos
        <br />

  Resplandor de la noche
        <br />
  Luminosidad sagrada del negro
        <br />
  Siglo XX
        <br />
  Años ‘50, Refinería
        <br />
  Planes sexenales y procesiones de Semana Santa
        <br />
  Convulsiones
        <br />
  Palomas
        <br />
  Conventos
        <br />
  Emperadores
        <br />
  Teatro y la guerra
        <br />
  Pequeños milagros
        <br />
  Sueños
        <br />
  Aire de París
        <br />
  Siluetas renacentistas
        <br />
  Nubes químicas
        <br />
  Seres de aire
        <br />
  Tristezas y atmósferas
        <br />
  Automóviles
        <br />
  Petróleos y otros fósiles
        <br />
  Dinosaurios y cometas
        <br />
  Alcantarillas y servicios eléctricos
        <br />
  Robots y sanguijuelas
        <br />
  Trenes trenes trenes
        <br />
  Chimeneas y otros altares
        <br />
  Modernidad desarrollo riquezas
        <br />
  Mercancía estiércol y charcos
        <br />
  Propiedad privada
        <br />
  Traición y gozo
        <br />
  Valles
        <br />
  Ovejas
        <br />
  Negrosobrenegrosobrenegrosobrenegrosobrenegrosobre
        <br />
  negrosobrenegrosobrenegrosobrenegrsobrenegrosobren
        <br />
  egrosobrenegrosobrenegro negronegronegronegronegro
        <br />
  Zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz
        <br />
  zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz
        <br />
  zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzźzzzzzzzzzzz
        <br />
  zzzzzzzzzzzzzzzzzzzzzzzzzzzz
        <br />
  SONIDOS CON LA PUNTA DE LA LENGUA
        <br />
  ENTRE LOS DIENTES, AIRE
        <br />
  zzzzzzzzzzzzzzzzzZzZzZzzzzzzzzzzzzzzzzzzzzzzzzzzz
  zzzzzzzzzzzzz
      </p>
    </Fragment>
  )
}


export default FragmentDV
